import styled from 'styled-components';
import { px2rem } from '../../../utils/helpers/style.js';
import { Link } from '../../../Link/Link.web.js';

var wrapper = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styles__wrapper",
  componentId: "sc-kcm797-0"
})(["padding:0;margin:0;display:flex;flex-direction:column;"]);
var item = /*#__PURE__*/styled.li.withConfig({
  displayName: "styles__item",
  componentId: "sc-kcm797-1"
})(["display:flex;align-items:center;justify-content:center;height:", ";border-bottom:2px dashed ", ";"], px2rem(68), function (p) {
  return p.theme.tokens.border.light;
});
var link = /*#__PURE__*/styled(Link).withConfig({
  displayName: "styles__link",
  componentId: "sc-kcm797-2"
})(["display:flex;align-items:center;justify-content:center;width:100%;height:", ";"], px2rem(68));

export { item, link, wrapper };
